module.exports = __webpack_public_path__ + "static/media/borrar.c4737cfd.png";